import { project2BaseUrl } from './remoteClient'

export const requestTemplates = (token) => {
    return project2BaseUrl.get("/templates/getTemplates", {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}


export const updateTemplate = (token, template) => {
    return project2BaseUrl.post("/templates/updateTemplate", template, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}

export const createTemplate = (token, template) => {
    return project2BaseUrl.post("/templates/createTemplate", template, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}

export const deleteTemplate = (token, templateId) => {
    return project2BaseUrl.post('/templates/deleteTemplate', templateId, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}

export const getTemplateSkills = (token, templateId) => {
    return project2BaseUrl.get(`/templates/getSkills?templateId=${templateId}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}

export const saveTemplateSkills = (token, templateId, skills) => {
    return project2BaseUrl.post(`/templates/createSkills?templateId=${templateId}`, skills, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}

export const updateTemplateSkills = (token, templateId, skills) => {
    return project2BaseUrl.post(`/templates/updateSkills?templateId=${templateId}`, skills, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}
